import React from 'react';

import './HomeTimeline.scss';


class HomeTimeline extends React.PureComponent {
    render() {

        return (
          <section className="homeTimeline">
              <div className="container">
                  <div className="homeTimeline_row">
                      <div className="homeTimeline_item">
                          <div className="homeTimeline_item_date">V roce 1995</div>
                          <div className="homeTimeline_item_desc">Otevíráme první pobočku <br/> v Ostravě</div>
                      </div>
                      <div className="homeTimeline_item">
                          <div className="homeTimeline_item_date">V roce 2000</div>
                          <div className="homeTimeline_item_desc">Otevíráme pobočku <br/> v Olomouci</div>
                      </div>
                      <div className="homeTimeline_item">
                          <div className="homeTimeline_item_date">V roce 2005</div>
                          <div className="homeTimeline_item_desc">Působíme také <br/> v Opavě</div>
                      </div>
                      <div className="homeTimeline_item">
                          <div className="homeTimeline_item_date">V roce 2010</div>
                          <div className="homeTimeline_item_desc">Pobočka ve <br/> Venezuele</div>
                      </div>
                      <div className="homeTimeline_item">
                          <div className="homeTimeline_item_date">V roce 2014</div>
                          <div className="homeTimeline_item_desc">Pobočka v <br/> Polsku</div>
                      </div>
                      <div className="homeTimeline_item">
                          <div className="homeTimeline_item_date">V roce 2016</div>
                          <div className="homeTimeline_item_desc">Pobočka v <br/> Itálii</div>
                      </div>
                      <div className="homeTimeline_item">
                          <div className="homeTimeline_item_date">Dnes</div>
                          <div className="homeTimeline_item_desc">A stále<br/> rosteme</div>
                      </div>
                  </div>
              </div>
          </section>
        );
    }
}

export default HomeTimeline;


// WEBPACK FOOTER //
// ./src/components/HomePage/HomeTimeline/HomeTimeline.js